enum PageStyle { Tan, Gray, DarkGrey }

export function getPageStyleClassName(pageStyle: PageStyle) {
    switch (pageStyle) {
        case PageStyle.Tan:
            return "tan-theme";
        case PageStyle.Gray:
            return "gray-theme";
        case PageStyle.DarkGrey:
            return "dark-grey-theme";
    }
}

export default PageStyle;